// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  compuscan: 'https://webservices-uat.compuscan.co.za/NormalSearchStreamService?wsdl',
  firebase: {
    apiKey: 'AIzaSyDwx-hgHLlwoqx1IxQxOL2yG-ExIwXnF3g',
    authDomain: 'landmarq-road-3b7cf.firebaseapp.com',
    databaseURL: 'https://landmarq-road-3b7cf.firebaseio.com',
    projectId: 'landmarq-road-3b7cf',
    storageBucket: '',
    messagingSenderId: '429044270302',
    appId: '1:429044270302:web:6f9d6b125ded91d2'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
